import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { MainScreenLayout } from '@components/MainScreenLayout';
import { useAuthStore } from '@stores/auth';
import {
  AcceptedOrderScreen,
  AcceptedOrdersScreen,
  LoginScreen,
  MenuScreen,
  NewOrderScreen,
  NewOrdersScreen,
  OrderHistoryScreen,
  OrdersHistoryScreen,
  TripsScreen,
} from '@pages';
import {
  WebNavigationContainer,
  WebNavigationDrawer,
} from '@providers/WebNavigationContainer';

export const AppRouter: React.FC = () => {
  const {
    computed: { isLoggedIn },
  } = useAuthStore();

  if (!isLoggedIn) {
    return <LoginScreen />;
  }

  return (
    <WebNavigationContainer>
      <BrowserRouter>
        <MainScreenLayout>
          <WebNavigationDrawer />

          <Routes>
            <Route path="/orders/new" element={<NewOrdersScreen />} />
            <Route path="/orders/new/:id" element={<NewOrderScreen />} />
            <Route path="/orders/accepted" element={<AcceptedOrdersScreen />} />
            <Route
              path="/orders/accepted/:id"
              element={<AcceptedOrderScreen />}
            />
            <Route
              path="/orders/history/:id"
              element={<OrderHistoryScreen />}
            />
            <Route path="/orders/history" element={<OrdersHistoryScreen />} />
            <Route path="/trips/*" element={<TripsScreen />} />
            <Route path="/menu" element={<MenuScreen />} />
            <Route path="*" element={<Navigate to="/orders/new" />} />
          </Routes>
        </MainScreenLayout>
      </BrowserRouter>
    </WebNavigationContainer>
  );
};
